import { Component } from '@angular/core';
import { SessionProvider } from '../../providers/session/session';
import { Router } from '@angular/router';
@Component({
    templateUrl: 'participant-page.html',
    selector: 'participant-page',
    styleUrls:['./participant-page.scss']
  })

  export class ParticipantPage {
      selectedSegment: string = "participant";
      athlete: boolean = false;
      team: any = {
        name: ''
      };
      selectedParticipant: string ='team-select';

      constructor(
        public sessionService: SessionProvider,
        private router:Router){
          const nav = this.router.getCurrentNavigation();
          const state = nav?.extras?.state || {};
          this.team = state['team'] || this.team;
        }

      public isLoged(): boolean {
        console.log("LOGED" + this.sessionService.isLoged);
        return this.sessionService.isLoged;
      }
  }